
const SonicLabLocationLink = ({className = "text-left mt-0 text-gray-600 underline", suburb, postcode}) => {
  return (
    <a href={`https://pathologylocations.com.au/locations/?suburb=${suburb}&postcode=${postcode}`} className={className} target="_blank">Click here to find a nearby pathology collection centre</a>
  )
}

export default SonicLabLocationLink
